import { render, staticRenderFns } from "./PointsDetails.vue?vue&type=template&id=218a4291&scoped=true"
import script from "./PointsDetails.vue?vue&type=script&lang=js"
export * from "./PointsDetails.vue?vue&type=script&lang=js"
import style0 from "./PointsDetails.vue?vue&type=style&index=0&id=218a4291&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218a4291",
  null
  
)

export default component.exports